@if (typeData) {
  <div class="grid">
    <div class="col-6" *ngFor="let typeId of typeData">
      @if (getTypeById(typeId); as layerType) {
        <div class="p-card surface-ground p-3">
          <div class="flex gap-3 align-items-center">
            <h4 class="mt-0 mb-2">
              <app-data-layer-type-name [dataLayerType]="layerType" />
            </h4>
          </div>
          @if (
            groupedData && groupedData[typeId] && getTypeDataLayers(typeId);
            as dataLayers
          ) {
            <app-year-list
              [indicatorId]="indicator._id"
              [dataLayers]="dataLayers" />
          }
        </div>
      }
    </div>
  </div>
} @else {
  <app-alert
    styleClass="pt-1 p-3"
    [canToggle]="false"
    header="Dem Indikator sind noch keine Daten
    zugeordnet"
    icon="fas fa-info-circle">
    @if (disableImportButton) {
      <p-button
        label="Daten importieren"
        icon="fas fa-cloud-upload"
        [rounded]="true"
        [routerLink]="[
          '/data-backend',
          { outlets: { overlay: ['cloud', { outlets: { panel: 'daten' } }] } },
        ]"></p-button>
    }
  </app-alert>
}
